import useSuperAdminUsersFetch from './hooks/useSuperAdminUsersFetch';
import { useSelector } from 'react-redux';

import SuperAdminUsersTable from './SuperAdminUsersTable';
import CreateSuperAdminUserModal from './CreateSuperAdminUserModal';
import Title from 'lib/src/components/typography/Title';
import CreateHeader from '@components/layout/createHeader/CreateHeader';
import LinkButton from '@components/button/LinkButton';
import { getSuperAdminUsers, getSuperAdminUsersIsFetching } from '@selectors/superAdminUsers';
import { useState } from 'react';
import UpdateSuperAdminModal from './UpdateSuperAdminModal';
import UpdateSuperAdminPasswordModal from './UpdateSuperAdminPasswordModal';
import DeleteSuperAdminModal from './DeleteSuperAdminModal';
import DowngradeSuperAdminModal from './DowngradeSuperAdminModal';

const SuperAdminUsers: React.FC<SuperAdminUsersProps> = ({ showCreateModal = false }) => {
    useSuperAdminUsersFetch();
    const superAdminUsers = useSelector(getSuperAdminUsers);
    const isFetching = useSelector(getSuperAdminUsersIsFetching);

    const [superAdminUserToEdit, setSuperAdminUserToEdit] = useState<number | null>(null);
    const [superAdminUserToEditPassword, setSuperAdminUserToEditPassword] = useState<number | null>(
        null,
    );
    const [superAdminUserToDelete, setSuperAdminUserToDelete] = useState<number | null>(null);
    const [superAdminUserToDowngrade, setSuperAdminUserToDowngrade] = useState<number | null>(null);

    return (
        <>
            <CreateHeader>
                <Title>Super Admins</Title>
                <LinkButton color="green" icon="plus" href="/superadmins/create">
                    Create
                </LinkButton>
            </CreateHeader>

            <SuperAdminUsersTable
                superAdminUsers={superAdminUsers}
                isFetching={isFetching}
                setSuperAdminUserToEdit={setSuperAdminUserToEdit}
                setSuperAdminUserToEditPassword={setSuperAdminUserToEditPassword}
                setSuperAdminUserToDelete={setSuperAdminUserToDelete}
                setSuperAdminUserToDowngrade={setSuperAdminUserToDowngrade}
            />
            {showCreateModal && <CreateSuperAdminUserModal />}
            {!!superAdminUserToEdit && (
                <UpdateSuperAdminModal
                    user={superAdminUsers[superAdminUserToEdit]}
                    closeModal={() => setSuperAdminUserToEdit(null)}
                />
            )}
            {!!superAdminUserToEditPassword && (
                <UpdateSuperAdminPasswordModal
                    user={superAdminUsers[superAdminUserToEditPassword]}
                    closeModal={() => setSuperAdminUserToEditPassword(null)}
                />
            )}
            {!!superAdminUserToDelete && (
                <DeleteSuperAdminModal
                    user={superAdminUsers[superAdminUserToDelete]}
                    closeModal={() => setSuperAdminUserToDelete(null)}
                />
            )}
            {!!superAdminUserToDowngrade && (
                <DowngradeSuperAdminModal
                    user={superAdminUsers[superAdminUserToDowngrade]}
                    closeModal={() => setSuperAdminUserToDowngrade(null)}
                />
            )}
        </>
    );
};

interface SuperAdminUsersProps {
    showCreateModal?: boolean;
}

export default SuperAdminUsers;
